import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";

// Components
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Tours from "./components/Tours";
import Restaurant from "./components/Restaurant";
import Wines from "./components/Wines";
import Testimonials from "./components/Testimonials";
import News from "./components/News";
import Reservation from "./components/Reservation";
import Footer from "./components/Footer";

// Auth Context
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

// Admin Pages
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import Customers from "./pages/admin/Customers";
import Reservations from "./pages/admin/Reservations";
import NewsManager from "./pages/admin/NewsManager";
import Conversations from "./pages/admin/Conversations";
import Prompts from "./pages/admin/Prompts";
import SiteConfig from "./pages/admin/SiteConfig";
import Gallery from "./pages/admin/Gallery";
import CustomerMap from "./pages/admin/CustomerMap";
import Stock from "./pages/admin/Stock";
import Sales from "./pages/admin/Sales";
import Suppliers from "./pages/admin/Suppliers";
import Accounting from "./pages/admin/Accounting";

// Proposal Pages
import ProposalAccess from "./pages/ProposalAccess";
import ProposalView from "./pages/ProposalView";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const checkApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log('API Status:', response.data.message);
    } catch (e) {
      console.error('API Error:', e);
    }
  };

  useEffect(() => {
    checkApi();
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Tours />
      <Restaurant />
      <Wines />
      <Testimonials />
      <News />
      <Reservation />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/web">
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Proposal Routes */}
            <Route path="/propuesta" element={<ProposalAccess />} />
            <Route path="/propuesta/view" element={<ProposalView />} />

            {/* Protected Admin Routes */}
            <Route element={<ProtectedRoute />}>
              <Route path="/admin" element={<AdminLayout />}>
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="news" element={<NewsManager />} />
                <Route path="config" element={<SiteConfig />} />
                <Route path="gallery" element={<Gallery />} />
                <Route path="conversations" element={<Conversations />} />
                <Route path="customers" element={<Customers />} />
                <Route path="reservations" element={<Reservations />} />
                <Route path="prompts" element={<Prompts />} />
                <Route path="map" element={<CustomerMap />} />
                <Route path="stock" element={<Stock />} />
                <Route path="sales" element={<Sales />} />
                <Route path="suppliers" element={<Suppliers />} />
                <Route path="accounting" element={<Accounting />} />
              </Route>
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
